var styles = {
  "Combo": "Online-Store-UI-Combo_bb44j",
  "readOnly": "Online-Store-UI-Combo--readOnly_1v8od",
  "focused": "Online-Store-UI-Combo--focused_zozno",
  "withHeader": "Online-Store-UI-Combo--withHeader_17y9p",
  "withFooter": "Online-Store-UI-Combo--withFooter_11kbu",
  "ToolbarWrapper": "Online-Store-UI-Combo__ToolbarWrapper_7x2zn",
  "unframed": "Online-Store-UI-Combo--unframed_14a90",
  "toneMagic": "Online-Store-UI-Combo--toneMagic_eg25w",
  "Children": "Online-Store-UI-Combo__Children_kzkps",
  "SlateWrapper": "Online-Store-UI-Combo__SlateWrapper_1u7bb",
  "Slate": "Online-Store-UI-Combo__Slate_b1pb7",
  "compact": "Online-Store-UI-Combo--compact_se5t8",
  "fullWidth": "Online-Store-UI-Combo--fullWidth_1nrj7",
  "fixedWidth": "Online-Store-UI-Combo--fixedWidth_1i92n"
};

export { styles as default };
